<div
  class="dashboard-header-container display-flex justify-content-space-between align-items-center grid-gap-8"
  [ngClass]="containerCss"
>
  <a
    [href]="previousRoute"
    (click)="goBack($event)"
    *ngIf="!!showBack"
    mat-button
    color="primary"
    class="back-to-parent"
  >
    <span class="display-flex align-items-center justify-content-center grid-gap-8">
      <app-icon
        [iconHeight]="24"
        [iconWidth]="24"
        [iconColor]="EColorPalette.cGreen3"
        [svg]="EIcon.ARROW_LEFT"
      ></app-icon>
      <span>Back</span>
    </span>
  </a>
  <div class="display-flex align-items-baseline flex-1 grid-gap-8 w-100">
    <ng-container
      [ngTemplateOutlet]="customHeaderTemplate ? customHeaderTemplate : defaultHeaderTemplate"
    ></ng-container>
  </div>
</div>

<ng-template #defaultHeaderTemplate>
  <ng-container
    [ngTemplateOutlet]="headerValue ? customHeaderValueTemplate : defaultHeaderValueTemplate"
  ></ng-container>
</ng-template>

<ng-template #defaultHeaderValueTemplate>
  <div class="display-flex justify-content-space-between flex-1">
    <div class="display-flex align-items-baseline grid-gap-8">
      <h3 class="text-color primary-light">Hello, {{ userData?.firstName || '' }}! 👋</h3>
      <ng-container
        *ngIf="{
          myTasksLoading: myTasksLoading$ | async,
          myTasksTurnovers: myTasksTurnovers$ | async,
          myTasksTickets: myTasksTickets$ | async,
          staleTurnovers: staleTurnovers$ | async,
          lateTurnovers: lateTurnovers$ | async
        } as data"
      >
        <div
          *ngIf="!data.myTasksLoading && (data.myTasksTurnovers || data.myTasksTickets)"
          class="body-small text-color gray11"
        >
          <span>
            {{ userData.id === assignee.value ? 'You have ' : '' }} {{ data.myTasksTurnovers }}
            {{ data.myTasksTurnovers === 1 ? 'turn' : 'turns' }} and {{ data.myTasksTickets }}
            {{ data.myTasksTickets === 1 ? 'ticket' : 'tickets' }}.
            <ng-container *ngIf="data.staleTurnovers">
              <span [ngClass]="PriorityType.Medium | priorityCss: true">{{ data.staleTurnovers }} stale</span>
            </ng-container>
            <ng-container *ngIf="data.staleTurnovers && data.lateTurnovers"> • </ng-container>
            <ng-container *ngIf="data.lateTurnovers">
              <span [ngClass]="PriorityType.High | priorityCss: true">{{ data.lateTurnovers }} late</span>
            </ng-container>
          </span>
        </div>
      </ng-container>
    </div>
    <div>
      <app-user-select-dropdown
        *ngIf="showAssigneeControl"
        [containerWidthCss]="'dashboard-assignee-selector'"
        [label]="'Assignee'"
        [labelCss]="'nowrap pre-title text-color gray7'"
        [valueCss]="'ellipsis text-color gray3 dropdown-value'"
        [optionCss]="'fade-truncate w-100 text-color gray3 dropdown-value'"
        [formControl]="assignee"
        [users]="users"
        [allowClear]="false"
        [allowSearch]="true"
        [labelInside]="true"
        [showMyOption]="true"
        [showAllOption]="true"
        [userData]="userData"
      ></app-user-select-dropdown>
    </div>
  </div>
</ng-template>

<ng-template #customHeaderValueTemplate>
  <h3 class="text-color primary-light">{{ headerValue || '' }}!</h3>
</ng-template>
